import styled from 'styled-components'
import { loadingPlaceholderAnimation } from '../../theme'
import { Box } from '../UI/Box'
import AnimatedLoader from '../AnimatedLoader'

const Container = styled.div`
  margin-top: 18px;
  display: flex;
  flex-direction: column;
  width: 100%;
  @media screen and (min-width: 1000px) {
    flex-direction: row;
    margin-top: 35px;
  }
`

export const LoadingPlaceholder = styled.div<{
  height?: number
  width?: number
  isTokenLogo?: boolean
  borderRadius?: number
}>`
  background: ${({ theme }) => theme.colors.loadingPlaceholderBG};
  overflow: hidden;
  border-radius: ${({ borderRadius }) => (borderRadius ? borderRadius : '0')}px;
  position: relative;
  height: ${({ height }) => height ? `${height}px` : '100%'};
  width: ${({ width }) => width ? `${width}px` : '100%'};
  ${({ width }) => loadingPlaceholderAnimation(width ? 510 / width : 1)};
`

const LoadingPlaceholderImage = styled(LoadingPlaceholder) <{
  isTokenLogo?: boolean
}>`
  ${({ isTokenLogo }) => loadingPlaceholderAnimation(isTokenLogo ? 7 : 1)}
  border-radius: ${({ isTokenLogo }) => (isTokenLogo ? 250 : 0)}px;
  @media screen and (min-width: 1000px) {
    height: ${({ isTokenLogo }) => (isTokenLogo ? 72 : 602)}px;
    width: ${({ isTokenLogo }) => (isTokenLogo ? 72 : 662)}px;
    max-width: ${({ isTokenLogo }) => (isTokenLogo ? 72 : 662)}px;
  }
`

const LoaderCont = styled(Box)`
  min-height: 600px;
`

const LoadingState = () => {
  return (
    <LoaderCont jc ac g={66}>
      <AnimatedLoader size={100} />
      {/* <LoadingPlaceholderImage />
      <ContentWrapper>
        <Header>
          <LoadingPlaceholderImage isTokenLogo />
        </Header>
        <Box marginTop={32} flex={0}>
          <LoadingPlaceholder height={24} width={183} borderRadius={100} />
        </Box>
        <Box marginTop={24} flex={0}>
          <LoadingPlaceholder height={14} width={668} borderRadius={100} />
        </Box>
        <Box marginTop={16} flex={0}>
          <LoadingPlaceholder height={14} width={548} borderRadius={100} />
        </Box>
      </ContentWrapper> */}
    </LoaderCont>
  )
}

export default LoadingState
